import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { MicrosoftAuthService } from '@services/core/authentication.service';

export const tokenInterceptorInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(MicrosoftAuthService);
  const token = authService.getToken();
  const sessionToken = authService.getSessionToken();

  let headers = req.headers
    .set('Content-Type', 'application/json; charset=utf-8')
    .set('Authorization', token || '');

  if (sessionToken) {
    headers = headers.set('x-session-token', sessionToken);
  }

  req = req.clone({ headers });

  return next(req);
};